export const __OBJECT_STRUCTURE_Obligation = (obligationId) => {
    return {
        id: obligationId,
        categoriaId: 0,
        categoriaNombre: "",
        nombre: "",
        nombreNemo: "",
        descripcion: "",
        periodoAlerta: 0,
        cumplirAntesVencimiento: null,
        postergarVencimiento: null,
        multaIncumplimiento: null,
        impedirAprobacionAdn: false,
        rolResponsableCumplimiento: "",
        requiereDocumento: null,
        sujetaAValidacion: null,
        periodica: false,
        activaPorDefecto: false,
        rolResponsableValidacion: "",
        clausulaMulta: "",
        periodicidadMeses: null,
        escalaTiempo: null,
        notificacion: null,
        aviso: null,
        respertarUbicacionReferencia: null,
        ultimoDiaMes: false,
        incluirEnChecklistEdp: null,
        subLegalEntityIds: [],
    }
}